__turbopack_context__.v({
  "cPhoneInput": "style-module-scss-module__9uc6oq__cPhoneInput",
});
